<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="!$route.meta.nokeepAlive" />
    </keep-alive> -->
    <router-view />
  </div>
</template>

<script>

export default {
  // watch: {
  //   $route(to, from) {
  //     if (to.name === "login" && from.name) {
  //       this.$router.go(0);
  //     }
  //   },
  // },
}
</script>


<style lang="scss">
#app {
  width:100%;
  height: 100%;
}
</style>
